import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import {
  GlobalAction,
  GlobalActions,
  PreiseStreckeErmittelt,
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { selectVorschaedenUeberschrittenProduktlinie } from '../../app/shared/selectors/vorschaeden.selector';
import { Merkmale } from '../reducers/merkmale.reducer';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';

export function* watchToggleProduktlinienActiveTrigger(): SagaIterator {
  yield takeEvery(VwgActions.MERKMALE_CHANGED, safeSaga(updateProduktlinienStatus, App.VWG));
  yield takeEvery(VwgActions.VORSCHAEDEN_CHANGED, safeSaga(updateProduktlinienStatus, App.VWG));
  yield takeEvery(
    GlobalActions.PREISE_STRECKE_ERMITTELT,
    safeSaga(handlePreiseStreckeErmittelt, App.VWG),
  );
  yield takeEvery(VwgActions.FEUER_CHANGED, safeSaga(updateProduktlinienStatus, App.VWG));
  yield takeEvery(VwgActions.LEITUNGSWASSER_CHANGED, safeSaga(updateProduktlinienStatus, App.VWG));
  yield takeEvery(VwgActions.STURMHAGEL_CHANGED, safeSaga(updateProduktlinienStatus, App.VWG));
  yield takeEvery(VwgActions.ELEMENTAR_CHANGED, safeSaga(updateProduktlinienStatus, App.VWG));
}

export function* handlePreiseStreckeErmittelt(action: GlobalAction<PreiseStreckeErmittelt>): SagaIterator {
  const state: IAppState = yield select();
  if (action.payload.appId === App.VWG && action.payload.angebotsId === state.angebotsId) {
    yield call(updateProduktlinienStatus);
  }
}

const vwgActions = new VwgActions();

export function* updateProduktlinienStatus(): SagaIterator {
  const appState: IAppState = cloneDeep(yield select());
  const merkmale = appState.merkmale;
  const produktlinien = appState.produkt.produktlinien;
  const vorschaedenUeberschritten: boolean = yield select(
    selectVorschaedenUeberschrittenProduktlinie,
  );
  const vorschaeden =
    appState.vorschaeden && appState.vorschaeden.vorhanden && vorschaedenUeberschritten;

  toggleProduktlinienActiveState(merkmale, produktlinien, vorschaeden);
  updateSelectedProduktlinie(produktlinien);
  const changeProduktlinienAction = vwgActions.produktlinienChanged(produktlinien);
  yield put(changeProduktlinienAction);
}

function toggleProduktlinienActiveState(
  merkmale: Merkmale,
  produktlinien: Produktlinie[],
  vorschaeden: boolean,
) {
  produktlinien.forEach(produktlinie => (produktlinie.deactivated = false));

  if (merkmale.denkmalschutz || merkmale.nichtDauerhaftBewohnt) {
    updateProduktlinienDeactivationStatus(
      produktlinien,
      true,
      Produktlinienname.BASIS,
      Produktlinienname.SMART,
      Produktlinienname.PREMIUM,
    );
  }

  if (vorschaeden) {
    updateProduktlinienDeactivationStatus(
      produktlinien,
      true,
      Produktlinienname.BASIS,
      Produktlinienname.SMART,
    );
  }

  if (merkmale.feuerrohbau) {
    updateProduktlinienDeactivationStatus(produktlinien, true, Produktlinienname.PREMIUM);
  }
}

function updateSelectedProduktlinie(produktlinien: Produktlinie[]) {
  const invalidProduktline = produktlinien.find(
    produktlinie => produktlinie.deactivated && produktlinie.selected,
  );
  if (invalidProduktline != null) {
    invalidProduktline.selected = false;
    const defaultProduktlinie = produktlinien.find(
      produktlinie => produktlinie.produktName === Produktlinienname.KOMFORT,
    );
    defaultProduktlinie.selected = true;
  }
}

function updateProduktlinienDeactivationStatus(
  produktlinien: Produktlinie[],
  deactivated: boolean,
  ...produktLines: Produktlinienname[]
) {
  produktlinien.forEach(tarifItem => {
    if (produktLines.includes(tarifItem.produktName)) {
      tarifItem.deactivated = deactivated;
    }
  });
}
